(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('VoucherSaleConfirmation', VoucherSaleConfirmation);

    VoucherSaleConfirmation.$inject = ['$resource', 'DateUtils'];

    function VoucherSaleConfirmation ($resource, DateUtils) {
        var resourceUrl =  'api/voucher-sale-confirmations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdAt = DateUtils.convertDateTimeFromServer(data.createdAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
